export default {"src":"/_next/static/media/todo.82379b9e.svg","height":768,"width":1024,"blurWidth":0,"blurHeight":0};